import React from 'react';
import { connect } from 'react-redux';
import Style from './DataControlEntity.module.css';

// Render a condition tree (API §11 shape) as a readable boolean expression.
const exprForGroup = (g) => {
  if (!g) return '';
  const parts = [];
  (g.conditions || []).forEach((c) => {
    const attr = c.attributeName || c.customAttributeName || 'attr';
    const se = c.serviceEntityName ? c.serviceEntityName.replace(/^Extension_/, '').replace(/_Service_Entity$/, '') : 'SE';
    const hasValue = c.value !== null && c.value !== undefined && c.value !== '';
    const hasValueTo = c.valueTo !== null && c.valueTo !== undefined && c.valueTo !== '';
    let val = '';
    if (c.operator === 'numberRange' && hasValue && hasValueTo) {
      val = ` "${c.value}" to "${c.valueTo}"`;
    } else if (hasValue) {
      val = ` "${c.value}"`;
    }
    parts.push(`${se}.${attr} ${c.operator}${val}`);
  });
  (g.groups || []).forEach((child) => {
    const inner = exprForGroup(child);
    if (inner) parts.push(`(${inner})`);
  });
  return parts.join(` ${g.logic || 'AND'} `);
};

const usedServiceEntities = (group, acc = new Set()) => {
  if (!group) return acc;
  (group.conditions || []).forEach((c) => {
    if (c.serviceEntityName) acc.add(c.serviceEntityName.replace(/^Extension_/, '').replace(/_Service_Entity$/, ''));
  });
  (group.groups || []).forEach((g) => usedServiceEntities(g, acc));
  return acc;
};

const ScanRules = (props) => {
  const { scanRules } = props;

  return (
    <div>
      <div style={{ marginBottom: 8 }}>
        <h1 className={Style.pageTitle}>Scan Rules</h1>
        <p className={Style.pageSubtitle}>Structural detection rules evaluated by the browser extension against the
          live DOM and runtime events — the engine layer beneath the curated Data Controls categories.
          This catalog is read-only and maintained by the platform.</p>
      </div>

      <div className={Style.engineNote}>
        Scan rules match content by <strong>DOM structure</strong> — tag, attribute, and event — rather than by content
        pattern alone. The detection rules in <strong>Governance → Data Controls</strong> resolve to scan rules here.
      </div>

      <div className={Style.card}>
        <div className={Style.cardHeader}><div className={Style.cardTitle}>Scan Rules</div></div>
        <div className={Style.cardBody}>
          <table className={Style.table}>
            <thead><tr>
              <th>#</th><th>Rule</th><th>Expression</th><th>Service Entities</th><th>Status</th>
            </tr></thead>
            <tbody>
              {(scanRules || []).map((r, i) => (
                <tr key={r.scanRuleId}>
                  <td>{r.iOrder || i + 1}</td>
                  <td><div className={Style.rowTitle}>{r.name}</div><div className={Style.rowDesc}>{r.description}</div></td>
                  <td><span className={Style.expr}>{exprForGroup(r.rootGroup) || '—'}</span></td>
                  <td>{[...usedServiceEntities(r.rootGroup)].map((n) => <span key={n} className={Style.chip}>{n}</span>)}</td>
                  <td>
                    <span className={`${Style.badge} ${r.isActive ? Style.low : Style.neutral}`}>
                      {r.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                </tr>
              ))}
              {(!scanRules || scanRules.length === 0) && (
                <tr><td colSpan={5} style={{ textAlign: 'center', padding: '20px', color: '#6b7280' }}>No scan rules</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  scanRules: state.entities.dataControlEntity.scanRules,
});

export default connect(mapStateToProps)(ScanRules);
